"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomZoom = void 0;
var React = require("react");
var react_slideshow_image_1 = require("react-slideshow-image");
exports.CustomZoom = function (data) {
    var zoomOutProperties = {
        indicators: false,
        scale: 0.4,
        duration: 3000,
        pauseOnHover: true,
        transitionDuration: 500,
        infinite: true,
        prevArrow: React.createElement(React.Fragment, null),
        nextArrow: React.createElement(React.Fragment, null)
    };
    return (React.createElement(react_slideshow_image_1.Zoom, __assign({}, zoomOutProperties, { autoplay: true, style: { width: "100%" } }), data.images.map(function (each, index) { return (React.createElement("div", { style: { width: "100%", textAlign: "center" }, key: "FirstDiv" + index },
        React.createElement("div", { key: "SecondDiv" + index, style: { display: "inline-block", margin: "auto" } },
            React.createElement("img", { style: { objectFit: "cover", width: "80%" }, src: each })))); })));
};
//# sourceMappingURL=CustomZoom.js.map